import { render, staticRenderFns } from "./add-edit-sponser.vue?vue&type=template&id=737650cc&scoped=true&"
import script from "./add-edit-sponser.vue?vue&type=script&lang=js&"
export * from "./add-edit-sponser.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-sponser.vue?vue&type=style&index=0&id=737650cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737650cc",
  null
  
)

component.options.__file = "add-edit-sponser.vue"
export default component.exports